import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorksQualitiControls(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].getRegulationsStagesPlanWorksQualitiControls,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksQualitiControlPreview(companyId, regulationId, stageId, planWorkId, qualitiControlId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].getRegulationsStagesPlanWorksQualitiControlPreview,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				qualitiControlId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksQualitiControlPopup(companyId, regulationId, stageId, planWorkId, qualitiControlId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].getRegulationsStagesPlanWorksQualitiControlPopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				qualitiControlId,
			},
		},
	)
}

function createRegulationsStagesPlanWorksQualitiControl(companyId, regulationId, stageId, planWorkId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].createRegulationsStagesPlanWorksQualitiControl, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
		...data,
	})
}

function getRegulationsStagesPlanWorksQualitiControl(companyId, regulationId, stageId, planWorkId, qualitiControlId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].getRegulationsStagesPlanWorksQualitiControl, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			qualitiControlId,
		},
	})
}

function patchRegulationsStagesPlanWorksQualitiControl(companyId, regulationId, stageId, planWorkId, qualitiControlId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].patchRegulationsStagesPlanWorksQualitiControl, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			qualitiControlId,
		},
		...data,
	})
}

function putRegulationsStagesPlanWorksQualitiControl(companyId, regulationId, stageId, planWorkId, qualitiControlId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].putRegulationsStagesPlanWorksQualitiControl, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			qualitiControlId,
		},
		...data,
	})
}

function deleteRegulationsStagesPlanWorksQualitiControl(companyId, regulationId, stageId, planWorkId, qualitiControlId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS].deleteRegulationsStagesPlanWorksQualitiControl, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			qualitiControlId,
		},
	})
}

export default {
	getRegulationsStagesPlanWorksQualitiControls,
	getRegulationsStagesPlanWorksQualitiControlPopup,
	getRegulationsStagesPlanWorksQualitiControlPreview,
	getRegulationsStagesPlanWorksQualitiControl,
	patchRegulationsStagesPlanWorksQualitiControl,
	putRegulationsStagesPlanWorksQualitiControl,
	createRegulationsStagesPlanWorksQualitiControl,
	deleteRegulationsStagesPlanWorksQualitiControl,
}
